export default "cómo\nPor qué\nCuántos\ncomo hacerlo"